import type { ApiFetchLastGamesPort } from '~/handlers/ports/api-fetch-last-games.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoAuthHeaders } from '~/utils/apostatudo/get-apostatudo-auth-headers';

export class ApostatudoApiFetchLastGamesAdapter
  implements ApiFetchLastGamesPort
{
  async handle() {
    try {
      // ENG-497: identidade vem do Bearer (gate EnsureUserTokenIdentity);
      // o userId só existe no composable, como chave do cache local.
      const url = `${getApostatudoApiUrl()}/last-games`;

      // Timeout de 5 segundos para não travar nada
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...getApostatudoAuthHeaders(),
        },
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      // Falha (inclui o 401 do gate ENG-496) vira null: o composable preserva
      // o cache local em vez de confundir com "sem jogos".
      if (!response.ok) {
        return null;
      }

      const data = await response.json();

      // API retorna array direto de LastGame[]
      return Array.isArray(data) ? data : [];
    } catch {
      return null;
    }
  }
}
